import { get, init } from "../lib/es6_global/src/EntrypointOptimize.bs";

// We store a copy of the fetch function in window.makerFetch
// This is to avoid the fetch function being overwritten by other scripts
// Very common for other trackers on the page to overwrite it.
window.makerFetch = window.makerFetch || window.fetch;

let accountId = (document.currentScript && new URL(document.currentScript.src).searchParams.get("id"));

window.maker_optimize = {
  ...(window.maker_optimize || {}),
  get,
};

// Wait for window.maker_optimize that might be appended
setTimeout(() => init(accountId), 0);
